module.exports = __webpack_public_path__ + "static/media/7.3a46898.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/majors/7.wav
// module id = uJtb
// module chunks = 0